<template>
  <div class="product-item relative-section" v-if="room">
    <a @click.prevent="onGoToDetail()" class="image-fit pointer">
      <img
        v-if="room.ImageIds && room.ImageIds.length > 0"
        :src="getImageUri(room.ImageIds[0])"
        alt
      />
      <img
        v-if="room.ImageIds && room.ImageIds.length === 0"
        src="../assets/images/product1.jpg"
        alt
      />
    </a>
    <div class="info-text">
      <h3 class="font-balo">
        <a @click.prevent="onGoToDetail()" class="pointer">
          {{ getTranslate(room.Name) }}
        </a>
      </h3>
      <div class="location font-bai" v-if="room.camping">
        <i>{{ room.camping.name }}</i>
      </div>
      <div class="des font-bai" v-html="getTranslate(room.Description)"></div>
      <ul
        class="pro-services list-inline font-bai font-bold"
        v-if="services && services.length"
      >
        <li
          class="item-inline"
          v-for="(service, index) in services"
          :key="index"
        >
          <img v-if="service.icon" :src="service.icon" alt />
          <img v-if="!service.icon" src="../assets/images/picscine.png" alt />
          {{ service.name }}
        </li>
      </ul>
    </div>
    <div class="info-price">
      <div class="time text-center">
        <b>
          <i>{{ getRoomBookTime() }}</i>
        </b>
      </div>
      <div class="price text-center">
        {{ $t("app.à partir de") }}
        <b>{{ getPrice() }} {{ currency.symbol }}</b>
      </div>
      <div class="text-center">
        <a @click.prevent="onGoToDetail()" class="btn font-bold pointer">
          {{ $t("app.en savoir plus") }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { CDN_MEWS_MEDIA } from "@/api/config";
import { mapState, mapActions, mapMutations } from "vuex";
import { get, first, filter, find } from "lodash";
import moment from "moment";
import { numberOfNightsBetweenDates } from "@/helper/calculateDays";
export default {
  name: "RoomListItem",
  props: ["room", "filter"],
  data() {
    return {
      services: []
    };
  },
  computed: {
    ...mapState({
      references: state => get(state, "hotels.allReferences", []),
      lang: state => get(state, "app.lang", "fr"),
      currency: state => get(state, "app.currency")
    })
  },
  mounted() {
    this.services = filter(
      get(this.room, "camping.services", []),
      item => item.inclus
    );
  },
  methods: {
    ...mapMutations("hotels", ["setFilter"]),
    ...mapActions("hotels", ["getRoom"]),
    getImageUri(image) {
      return `${CDN_MEWS_MEDIA}/Image/${image}?Mode=Fit&Height=161`;
    },
    getTranslate(object) {
      if (this.lang === "fr" && get(object, "fr-FR")) {
        return get(object, "fr-FR");
      }
      return get(object, "en-US");
    },
    getRoomBookTime() {
      const dateFrom = moment(new Date(this.filter.dateFrom)).format("ddd DD");
      const dateTo = moment(new Date(this.filter.dateTo)).format("ddd DD");
      const totalDate = numberOfNightsBetweenDates(
        moment(new Date(this.filter.dateFrom)),
        moment(new Date(this.filter.dateTo))
      );
      if (totalDate > 1) {
        return `${this.$i18n.t("app.Du")} ${dateFrom} ${this.$i18n.t(
          "app.au"
        )} ${dateTo}. (${totalDate} ${this.$i18n.t("app.nuits")})`;
      } else {
        return `${this.$i18n.t("app.Du")} ${dateFrom} ${this.$i18n.t(
          "app.au"
        )} ${dateTo}. (${totalDate} ${this.$i18n.t("app.nuit")})`;
      }
    },
    getPrice() {
      const roomOccupancyAvailabilities = first(
        this.room.RoomOccupancyAvailabilities
      );
      return get(
        roomOccupancyAvailabilities,
        `Pricing.0.Price.AveragePerNight.${this.currency.code}`
      );
    },
    onGoToDetail() {
      const roomId = this.room.Id;
      const roomCategory = find(this.references, item => item.id === roomId);
      if (roomCategory) {
        this.getRoom(roomCategory)
          .then(res => {
            this.setFilter({
              ...this.filter,
              categorie: get(res, "category.id")
            });
            this.$router.push(`/room/${roomId}`);
          })
          .catch(() => this.$router.push("/"));
      } else {
        this.$router.push("/");
      }
    }
  }
};
</script>
